import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Although human voice (dialogue, commentary, etc.) is a valid content that is typically included in the listening tests like presented previously, a dedicated set of methods has been defined over the years for speech quality assessment in real-time communication systems. In this section, we provide an example of a custom test methodology used to evaluate noise and echo reduction. </br></br>In this section, you will listen to the fragment of a recording of a conversation that was conducted without noise reduction and echo cancellation. Rate your perceived speech quality by answering the following questions.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0226/q1.html`,
            },
          },
        },
      },
    },
  },
};

export default principle;
